/**
 * Dashboard Service
 * API calls for admin dashboard
 */

import api from './api';

export const dashboardService = {
  // Get dashboard overview stats
  getStats: () => api.get('/dashboard/stats'),

  // Get recent activity
  getRecentActivity: (limit = 10) => api.get('/dashboard/activity', { limit }),

  // Get session analytics
  getSessionAnalytics: (period = 30) => api.get('/dashboard/analytics/sessions', { period }),

  // Get user analytics
  getUserAnalytics: (period = 30) => api.get('/dashboard/analytics/users', { period }),

  // Get organization analytics
  getOrganizationAnalytics: (period = 30) => api.get('/dashboard/analytics/organizations', { period }),

  // Get engagement analytics
  getEngagementAnalytics: (period = 30) => api.get('/dashboard/analytics/engagement', { period }),
};

export default dashboardService;
